const menu = {
  'menu.company': 'Empresa',
  'menu.contactUs': 'Contáctanos',
  'menu.privacyPolicy': 'Política de privacidad',
  'menu.terms': 'Términos y condiciones',
  'menu.howToMakeGoodApp': '¿Cómo aplicar?',
  'menu.covid': 'Covid-19',
  'menu.aboutTefl': 'Acerca de TEFL',
  'menu.lifeInBarcelona': 'Vida en Barcelona',
  'menu.lifeInSeville': 'Vida en Sevilla',
  'menu.aboutUsFooter': 'Sobre nosotros',
  'menu.spanishCourses': 'Catalan y Curso Docente Avanzado',

  'menu.helpCenter': 'Centro de ayuda',
};

export default menu;
